// import { zodResolver } from "@hookform/resolvers/zod";
// import {
//   Button,
//   Divider,
//   Input,
//   Link,
//   Select,
//   SelectItem,
// } from "@heroui/react";
// import { useState } from "react";
// import { Controller, useForm } from "react-hook-form";
// import { FaExclamationTriangle } from "react-icons/fa";
// import { toast } from "sonner";
//
// import { Form } from "../../components/ui/form";
//
// import {
//   registerSchema,
//   TRegisterSchema,
// } from "@/models/Authentication.Schema.ts";
// import { useRegister } from "@/features/Auth/AuthApi.ts";
// import { FlipWords } from "@/components/ui/flip-words.tsx";
//
// const Register = () => {
//   const [isVisible] = useState(false);
//   const [isConfirmVisible] = useState(false);
//   const [latitude, setLatitude] = useState<string>();
//   const [longitude, setLongitude] = useState<string>();
//
//   const form = useForm<TRegisterSchema>({
//     resolver: zodResolver(registerSchema),
//     defaultValues: {
//       firstname: "",
//       lastname: "",
//       email: "",
//       password: "",
//       role: "",
//     },
//   });
//
//   const { mutateAsync, reset } = useRegister();
//
//   navigator?.geolocation?.getCurrentPosition((position) => {
//     setLatitude(position.coords.latitude.toString());
//     setLongitude(position.coords.longitude.toString());
//     // console.log(latitude, longitude);
//   });
//
//   const onSubmit = async () => {
//     const registerData = {
//       firstname: form.getValues("firstname"),
//       lastname: form.getValues("lastname"),
//       email: form.getValues("email"),
//       role: form.getValues("role"),
//       latitude: latitude,
//       longitude: longitude,
//       password: form.getValues("password"),
//     };
//
//     console.log(form.formState.errors);
//
//     try {
//       toast.promise(mutateAsync(registerData), {
//         loading: "Registering User...",
//         success: "Registered Successfully",
//         position: "top-right",
//         duration: 1000,
//       });
//       // console.log(registerData);
//       reset();
//       form.reset();
//     } catch (error) {
//       // console.log(error);
//     }
//   };
//
//   return (
//     <div className="flex h-full px-10 w-full relative top-10 mb-8 justify-center
// "> <div className=" flex h-fit w-full max-w-sm flex-col gap-4 rounded-large  px-6
// py-4  shadow-small"> <div className="pb-6 text-center"> <h1
// className="animate-[gradient_6s_linear_infinite]
// bg-[linear-gradient(to_right,theme(colors.gray.200),
// theme(colors.indigo.200),theme(colors.gray.50),
// theme(colors.indigo.300),theme(colors.gray.200))] bg-[length:200%_auto]
// bg-clip-text font-nacelle text-3xl font-semibold text-gray-600 sm:text-4xl" >
// Create an account </h1> </div> <Form {...form}> <form className="flex flex-col
// gap-4" onSubmit={form.handleSubmit(onSubmit)} > <div className="flex flex-row
// gap-3"> <Controller control={form.control} defaultValue="" name="firstname"
// render={({ field }) => ( <Input {...field} isClearable isRequired
// className="placeholder:select-none select-none" errorMessage={
// form.formState.errors.firstname && ( <div className="flex flex-row gap-2
// items-center text-rose-600 text-sm pb-1 "> <FaExclamationTriangle color="danger"
// /> <span>{`${form.formState.errors.firstname.message}`}</span> </div> ) }
// id="firstname" data-testid={"firstname-id"} label="Firstname" name="firstname"
// size={"sm"} type="text" variant="flat" /> )} /> <Controller
// control={form.control} defaultValue="" name="lastname" render={({ field }) => (
// <Input {...field} isClearable isRequired className="placeholder:select-none
// select-none" errorMessage={ form.formState.errors.lastname && ( <div
// className="flex flex-row gap-2 items-center text-rose-600 text-sm pb-1 ">
// <FaExclamationTriangle color="danger" />
// <span>{`${form.formState.errors.lastname.message}`}</span> </div> ) }
// id="lastname" data-testid={"lastname-id"} label="Lastname" name="lastname"
// size={"sm"} type="text" variant="flat" /> )} /> </div>  <Controller
// control={form.control} defaultValue="" name="email" render={({ field }) => (
// <Input {...field} isClearable isRequired className="placeholder:select-none
// select-none" errorMessage={ form.formState.errors.email && ( <div className="flex
// flex-row gap-2 items-center text-rose-600 text-sm pb-1 "> <FaExclamationTriangle
// color="danger" /> <span>{`${form.formState.errors.email.message}`}</span> </div> ) } id="email" data-testid={"email-id"} label="Email Address" name="email" size={"sm"} type="email" variant="flat" /> )} />  <Controller control={form.control} defaultValue="" name="role" render={({ field }) => ( <Select {...field} isRequired className="max-w-sm placeholder:select-none select-none" errorMessage={ form.formState.errors.role && ( <div className="flex flex-row gap-2 items-center text-rose-600 text-sm pb-1 "> <FaExclamationTriangle color="danger" /> <span>{`${form.formState.errors.role.message}`}</span> </div> ) } id="role" data-testid={"role-id"} label="Role" name="role" size={"sm"} > <SelectItem key={"Farmer"} // value={ "Farmer" } > Farmer </SelectItem> </Select> )} />  <Controller control={form.control} defaultValue="" name="password" render={({ field }) => ( <Input {...field} isClearable isRequired aria-label="Password" className="placeholder:select-none select-none" errorMessage={ form.formState.errors.password && ( <div className="flex flex-row gap-2 items-center text-rose-600 text-sm pb-1 "> <FaExclamationTriangle color="danger" /> <span>{`${form.formState.errors.password.message}`}</span> </div> ) } data-testid={"password-id"} id="password" label="Password" name="password" size={"sm"} type={isVisible ? "text" : "password"} variant="flat" /> )} /> <Controller control={form.control} defaultValue="" name="confirmPassword" render={({ field }) => ( <Input {...field} isClearable isRequired errorMessage={ form.formState.errors.confirmPassword && ( <div className="flex flex-row gap-2 items-center text-rose-600 text-sm pb-1 "> <FaExclamationTriangle color="danger" /> <span>{`${form.formState.errors.confirmPassword.message}`}</span> </div> ) } id="confirmPassword" data-testid={"confirmPasswordId"} label="Confirm Password" name="confirmPassword" type={isConfirmVisible ? "text" : "password"} variant="flat" size={"sm"} // aria-label="Password" className="placeholder:select-none select-none" /> )} />  <Button data-testid={"signUP"} color={"primary"} radius={"sm"} type="submit" > Sign Up </Button> </form> </Form> <div className="flex items-center gap-4"> <Divider className="flex-1" /> </div>  <div className="text-center text-small select-none text-gray-600"> Already have an account?&nbsp; <Link href="/login" size="sm"> <FlipWords words={["Sign In", "Login"]} /> <br /> </Link> </div> </div> </div> ); };  export default Register;

import { zodResolver } from "@hookform/resolvers/zod";
import {
  Button,
  Card,
  Divider,
  Image,
  Input,
  Link,
  Select,
  SelectItem,
} from "@heroui/react";
import { useEffect, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { toast } from "sonner";
import { TailSpin } from "react-loader-spinner";

// Import Carousel and related components
import Autoplay from "embla-carousel-autoplay";
import {
  Carousel,
  CarouselContent,
  CarouselItem,
} from "@/components/ui/carousel";

// Import local assets (ensure paths are correct)
import cover1 from "/public/cover1.jpg";
import cover3 from "/public/cover3.jpg";
import cover4 from "/public/cover4.jpg";
import cover5 from "/public/cover5.jpg";
import cover6 from "/public/cover6.jpg";

import { useRegister } from "@/features/Auth/AuthApi.ts";
import {
  registerSchema,
  TRegisterSchema,
} from "@/models/Authentication.Schema.ts";

// Reusable Carousel Component from the AuthPage
function CarouselPlugin({ image }: { image: string[] }) {
  return (
    <Carousel
      plugins={[
        Autoplay({
          delay: 10000,
          playOnInit: true,
          active: true,
          stopOnInteraction: false,
        }),
      ]}
      className=" w-full h-screen shadow-gray-800 shadow-lg "
    >
      <CarouselContent className={""}>
        {image.map((url, index: any) => (
          <CarouselItem
            key={index}
            className="w-full z-[-1] h-screen rounded-none"
          >
            <Image
              src={url}
              isBlurred
              isZoomed
              height="100vh"
              alt={`Cover ${index + 1}`}
              className=" object-fit z-[-1] rounded-none bg-white/30 backdrop-blur-none"
            />
            {/* <div className="absolute w-full bottom-6 px-6 z-50 flex flex-col items-end justify-end gap-4 "> */}
            {/*   <User */}
            {/*     className="backdrop-blur-[20px]" */}
            {/*     avatarProps={{ */}
            {/*       src: "https://i.pravatar.cc/150?u=a04258a2462d826712d", */}
            {/*     }} */}
            {/*     classNames={{ */}
            {/*       base: "flex flex-row-reverse", */}
            {/*       name: "w-full text-right text-black", */}
            {/*       description: "text-black", */}
            {/*     }} */}
            {/*     description="Founder & CEO at ACME" */}
            {/*     name="Bruno Reichert" */}
            {/*   /> */}
            {/*   <p className="w-full z-50 text-right text-2xl text-black backdrop-blur-[20px] rounded-2xl"> */}
            {/*     <span className="font-medium ">“</span> */}
            {/*     <span className="font-normal italic"> */}
            {/*       Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nunc */}
            {/*       eget augue nec massa volutpat aliquet. */}
            {/*     </span> */}
            {/*     <span className="font-medium">”</span> */}
            {/*   </p> */}
            {/* </div> */}
          </CarouselItem>
        ))}
      </CarouselContent>
    </Carousel>
  );
}

const Register = () => {
  const [latitude, setLatitude] = useState<string>();
  const [longitude, setLongitude] = useState<string>();
  const { mutateAsync, isPending, reset } = useRegister();

  const form = useForm<TRegisterSchema>({
    resolver: zodResolver(registerSchema),
    defaultValues: {
      firstname: "",
      lastname: "",
      email: "",
      password: "",
      confirmPassword: "",
      role: "",
    },
  });

  // This effect will run once to get the user's location.
  useEffect(() => {
    navigator?.geolocation?.getCurrentPosition((position) => {
      setLatitude(position.coords.latitude.toString());
      setLongitude(position.coords.longitude.toString());
    });
  }, []);

  const onSubmit = async (data: TRegisterSchema) => {
    const registerData = {
      ...data,
      latitude,
      longitude,
    };

    toast.promise(mutateAsync(registerData), {
      loading: "Creating your account...",
      success: () => {
        reset();
        form.reset();
        return "Registered Successfully! Please check your email to verify.";
      },
      error: (error: any) => {
        return (
          error?.response?.data?.message ||
          "Registration failed. Please try again."
        );
      },
      position: "top-right",
    });
  };

  const img: string[] = [cover1, cover3, cover4, cover5, cover6];

  return (
    <div className="relative flex h-screen w-screen flex-row justify-between items-center dark:bg-black overflow-hidden bg-gradient-to-r from-gray-50 via-blue-50 to-yellow-50">
      {/* Registration Form */}
      <div className="flex flex-col lg:container w-full items-center bg-transparent lg:w-1/2">
        <Card className={"lg:w-[450px] w-full max-w-md p-4"}>
          <div className="flex w-full flex-col items-center gap-4 p-4">
            <div className="w-full text-left">
              <p className="pb-2 text-xl font-medium">Create an Account</p>
              <p className="text-small text-default-500">
                Get started by filling out the form below.
              </p>
            </div>

            <div className="flex w-full items-center gap-4 py-2">
              <Divider className="flex-1" />
            </div>

            <form
              className="flex w-full flex-col gap-3"
              onSubmit={form.handleSubmit(onSubmit)}
            >
              <div className="flex flex-row gap-4">
                <Controller
                  control={form.control}
                  name="firstname"
                  render={({ field }) => (
                    <Input
                      {...field}
                      isClearable
                      isRequired
                      label="First Name"
                      color="success"
                      variant="underlined"
                      errorMessage={form.formState.errors.firstname?.message}
                      classNames={{
                        label: "text-[#008c8fff]",
                      }}
                      onClear={() => form.resetField("firstname")}
                    />
                  )}
                />
                <Controller
                  control={form.control}
                  name="lastname"
                  render={({ field }) => (
                    <Input
                      {...field}
                      isClearable
                      isRequired
                      label="Last Name"
                      color="success"
                      variant="underlined"
                      errorMessage={form.formState.errors.lastname?.message}
                      classNames={{
                        label: "text-[#008c8fff]",
                      }}
                      onClear={() => form.resetField("lastname")}
                    />
                  )}
                />
              </div>

              <Controller
                control={form.control}
                name="email"
                render={({ field }) => (
                  <Input
                    {...field}
                    isClearable
                    isRequired
                    type="email"
                    label="Email Address"
                    color="success"
                    variant="underlined"
                    errorMessage={form.formState.errors.email?.message}
                    classNames={{
                      label: "text-[#008c8fff]",
                    }}
                    onClear={() => form.resetField("email")}
                  />
                )}
              />

              <Controller
                control={form.control}
                name="role"
                render={({ field }) => (
                  <Select
                    {...field}
                    isRequired
                    label="Select your Role"
                    variant="underlined"
                    color="success"
                    errorMessage={form.formState.errors.role?.message}
                    classNames={{
                      label: "text-[#008c8fff]",
                    }}
                  >
                    <SelectItem key={"Farmer"}>Farmer</SelectItem>
                    {/* Add other roles here if needed */}
                  </Select>
                )}
              />

              <Controller
                control={form.control}
                name="password"
                render={({ field }) => (
                  <Input
                    {...field}
                    isClearable
                    isRequired
                    type="password"
                    label="Password"
                    color="success"
                    variant="underlined"
                    errorMessage={form.formState.errors.password?.message}
                    classNames={{
                      label: "text-[#008c8fff]",
                    }}
                    onClear={() => form.resetField("password")}
                  />
                )}
              />
              <Controller
                control={form.control}
                name="confirmPassword"
                render={({ field }) => (
                  <Input
                    {...field}
                    isClearable
                    isRequired
                    type="password"
                    label="Confirm Password"
                    color="success"
                    variant="underlined"
                    errorMessage={
                      form.formState.errors.confirmPassword?.message
                    }
                    classNames={{
                      label: "text-[#008c8fff]",
                    }}
                    onClear={() => form.resetField("confirmPassword")}
                  />
                )}
              />

              <Button
                className={"bg-[#008c8fff] text-white mt-4"}
                variant="shadow"
                isLoading={isPending}
                spinner={
                  <TailSpin
                    height="24"
                    width="24"
                    color="#ffffff"
                    ariaLabel="tail-spin-loading"
                    radius="1"
                    visible={true}
                  />
                }
                type="submit"
              >
                Sign Up
              </Button>
            </form>

            <p className="text-center text-[#008c8fff] text-small mt-2">
              Already have an account?
              <Link href="/login" size="sm">
                Log In
              </Link>
            </p>
          </div>
        </Card>
      </div>

      {/* Right side - Image Carousel */}
      <div className={"w-full hidden lg:block lg:w-1/2"}>
        <CarouselPlugin image={img} />
      </div>
    </div>
  );
};

export default Register;
